<template>
  <div
    v-if="typeof calAlertType === 'number' && ~calAlertType"
    class="mention-container"
    :class="[{ mobile: isMobile }, calAlertTypeClass]"
  >
    <div class="mention-content">
      <div class="status-icon" :class="calAlertTypeClass"></div>
      <div class="text">
        {{ $t(`propTrade.history.status.${calAlertType}`) }}
      </div>
    </div>
    <div class="mention-action" v-show="calAlertType === METRICS_STATUS.FAILED">
      <el-button class="blue_button action-button" :data-testid="join" @click.prevent="join" type="primary">
        {{ $t('propTrade.button.join') }}
      </el-button>
    </div>
    <div class="mention-action" v-show="calAlertType === METRICS_STATUS.PROFIT_SPLITTED">
      <el-button class="blue_button action-button" data-testid="payout" @click.prevent="checkPoaAndShowPayoutDialog" type="primary">
        {{ $t('propTrade.button.payout') }}
      </el-button>
    </div>
    <el-dialog class="payout-dialog" width="460px" :visible.sync="showPayoutDialog" top="0">
      <div class="payout-content">
        <div class="title">
          {{ $t('propTrade.payoutPage.howToProcessYourProfitSplit') }}
        </div>
        <div class="desc">
          {{ $t('propTrade.payoutPage.howToProcessYourProfitSplitDesc') }}
        </div>
        <div class="desc">
          {{ $t('propTrade.payoutPage.howToProcessYourProfitSplitDesc2') }}
        </div>
        <div class="desc">
          {{ $t('propTrade.payoutPage.howToProcessYourProfitSplitDesc3') }}
        </div>
        <div class="desc">
          {{ $t('propTrade.payoutPage.howToProcessYourProfitSplitDesc4') }}
        </div>
        <div class="desc">
          {{ $t('propTrade.payoutPage.howToProcessYourProfitSplitDesc5') }}
        </div>
      </div>
      <div class="but_wrapper">
        <el-button class="white_button" @click="showPayoutDialog = false">
          {{ $t('propTrade.button.cancel') }}
        </el-button>
        <el-button :data-testid="gotoPayout" @click="gotoPayout" type="primary" class="blue_button">
          {{$t('propTrade.payoutPage.submit')}}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog class="mention-dialog" :visible.sync="showPoaDialog" @click="showPoaDialog = false" top="0">
      <template #title>
        <div class="info-head">
          <img class="info-head-icon" :src="require(`@/assets/images/propTrade/dialog_fail.png`)" alt="infoType" />
          <div class="info-head-title">
            {{ $t('propTrade.payoutPage.poaDialog.title') }}
          </div>
        </div>
      </template>
      <div class="info-container">
        <p>{{ $t('propTrade.payoutPage.poaDialog.message') }}</p>
      </div>

      <div class="but_wrapper">
        <el-button class="close-btn" @click="showPoaDialog = false">{{ $t('propTrade.button.cancel') }}</el-button>
        <el-button class="blue_button" type="primary" @click="verifyNow">{{ $t('propTrade.button.verifyNow') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { METRICS_STATUS } from '@/constants/propTrade';
import { statusConfig } from '@/util/propTrading/status';
export default {
  name: 'PropTradingMetrics',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    alertType: {
      type: Number | String,
      default: METRICS_STATUS.DEFAULT
    },
    accountNumber: {
      type: Number | String,
      default: ''
    }
  },
  data() {
    return {
      METRICS_STATUS,
      showPayoutDialog: false,
      showPoaDialog: false
    };
  },
  components: {},
  computed: {
    ...mapState('common', ['poaAuditStatus']),
    calAlertType() {
      return this.alertType;
    },
    calAlertTypeClass() {
      return (
        {
          [METRICS_STATUS.PASSED]: 'check',
          [METRICS_STATUS.FAILED]: 'fail',
          [METRICS_STATUS.VERIFYING]: 'check',
          [METRICS_STATUS.PROFIT_PENDING]: 'processing',
          [METRICS_STATUS.PROFIT_SPLITTED]: 'processing',
          [METRICS_STATUS.WARNING]: 'info'
        }[this.calAlertType] ?? ''
      );
    }
  },
  mounted() {},
  methods: {
    join() {
      this.$router.push({ path: '/propTrading/createAccount' });
    },
    async gotoPayout() {
      if (this.accountNumber) {
        await this.$router
          .push({
            name: 'propTradingPayout',
            params: { accountNumber: encodeURIComponent(this.accountNumber) }
          })
          .catch(() => {});
      }
    },
    checkPoaAndShowPayoutDialog() {
      if (this.poaAuditStatus !== statusConfig.completed) {
        this.showPoaDialog = true;
      } else {
        this.showPayoutDialog = true;
      }
    },
    async verifyNow() {
      await this.$router.push({ name: 'register' }).catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.mention-container {
  margin: 32px 0;
  padding: 9px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px;
  background-color: #e8ffea;
  color: #000;
  &.info {
    background-color: #fff7e8;
  }
  &.fail {
    background-color: #ffece8;
  }
  &.processing {
    background-color: #f2f6ff;
  }

  .mention-content {
    display: flex;
    align-items: center;
    flex: 1;
    .status-icon {
      flex: 0 0 30px;
      @include rtl-sass-prop(margin-right, margin-left, 8px);
      width: 24px;
      height: 24px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;

      &.check {
        background-image: url('~@/assets/images/propTrade/trade_check.png');
      }
      &.info {
        background-image: url('~@/assets/images/propTrade/trade_info.png');
      }
      &.fail {
        background-image: url('~@/assets/images/propTrade/trade_fail.png');
      }
      &.processing {
        background-image: url('~@/assets/images/propTrade/trade_processing.png');
      }
    }
    .text {
      line-height: 24px;
    }
  }

  .mention-action {
    .action-button {
      min-width: 96px;
      padding: 8px 15px;
      font-size: 14px;
      font-weight: 500;
      color: #f5f5f7;
      background-color: $primary-blue;
      border-radius: 33px;
      line-height:1;
    }
  }

  &.mobile {
    margin-top: 16px;
    margin-bottom: 20px;
    padding: 18px;
    flex-direction: column;
    justify-content: center;
    .mention-content {
      width: 100%;
    }
    .mention-action {
      width: 100%;
      margin-top: 12px;
    }
  }
}

.payout-dialog {
  position: absolute;
  /deep/ .el-dialog {
    padding: 40px;
  }

  .title {
    font-weight: 700;
    font-size: 20px;
    color: $title-color;
    margin-bottom: 24px;
    text-align: center;
  }
  .desc {
    font-weight: 400;
    font-size: 12px;
    color: $title-color;
    padding-bottom: 20px;
  }

  .payout-content {
    display: flex;
    flex-direction: column;
    margin-bottom: 12px;
    color: #232020;
  }
}

.mention-dialog {
  text-align: center;
  position: absolute;

  .info-head {
    display: flex;
    flex-direction: column;
    align-items: center;

    &-icon {
      width: 70px;
      height: 70px;
    }
    &-title {
      font-weight: 700;
      font-size: 20px;
      line-height: 27.24px;
      margin: 12px 0px 20px 0;
      color: #000a2d;
    }
  }

  .info-container {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.3px;
    margin-bottom: 32px;
    align-items: center;
    color: #232020;
    width: 100%;
    ;
  }

  /deep/ .el-dialog {
    max-width: 480px;
    padding: 36px 40px 40px 40px;

    .el-dialog__header {
      margin-bottom: 0px;
      padding:0px !important;
    }
  }
}

.but_wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .el-button {
    width: 48%;
    border-radius: 30px;
  }
}

/deep/  .el-dialog__wrapper .el-dialog__body {
  padding: 0px;
}

@media (max-width: 768px) {
  .mention-dialog,
  .payout-dialog {
    /deep/ .el-dialog {
      top: 50% !important;
      transform: translateY(-50%);
      margin-top: 0 !important;
    }
  }
  .mention-action {
    text-align: center;
  }
  .blue_button,
  .white_button {
    margin-bottom: 0;
  }
}

@media (max-width: 640px) {
  .mention-dialog,
  .payout-dialog {
    /deep/ .el-dialog {
      max-width: 348px;
    }
    .info-head {
    &-title {
      font-size: 16px;
    }
    }
    .info-container {
      font-size: 12px
    }

    .title {
      font-size: 16px;
    }
  }
}
</style>
